module.exports = __webpack_public_path__ + "static/media/fylo-dark-theme.9f8c9989.jpg";